module.exports = __webpack_public_path__ + "static/media/menu.7617b3d3.svg";